<app-selection-list
  heightClass="tw-h-96"
  [label]="input_label"
  [form]="input_form"
  [controlName]="input_formControlName"
  [isRequired]="isRequired"
  [searchLabel]="input_searchLabel"
  [items]="items"
  [loading]="loading"
  [id]="id"
  [values]="values"
  [optionTitle]="optionTitle"
  [optionValue]="optionValue"
  [sortKey]="sortKey"
  [isReadOnly]="isReadOnly"
  [customSortArray]="customSortArray"
  [isSmallSize]="isSmallSize"
  [responsiveClass]="input_responsiveClass"
  [searchBoxGridClass]="input_searchBoxGridClass"
  [optionCustomClass]="input_optionCustomClass"
  [isShowSelectAll]="isShowSelectAll"
  (values)="emitValues($event)"
  (items)="emitItems($event)"
  [hasCustomClass]="hasCustomClass"
>
  <custom-select-search
    *ngIf="showPrivacyDropdown"
    class="tw-w-1/2 small-select"
    label="common.type"
    [items]="
      $any([
        { value: '', name: 'common.all' | translate },
        { value: PhonebookTypes.Private, name: 'common.private' | translate },
        { value: PhonebookTypes.Public, name: 'common.public' | translate },
        {
          value: PhonebookTypes.ParentPublic,
          name: 'common.parentPublic' | translate
        }
      ])
    "
    optionTitle="name"
    optionValue="value"
    [removable]="false"
    (valueChange)="onChangeType($event)"
  >
  </custom-select-search>
</app-selection-list>
